import { gql, useMutation } from '@apollo/client'

const QUESTION_CREATE_MUTATION = gql`
  mutation QuestionCreate($question: QuestionCreate!) {
    questionCreate(question: $question) {
      id
      type
      text
      textFuture
      description
      associatedLink
      notApplicable
      dimension {
        id
        name
      }
      options {
        value
      }
      recommendations {
        stage {
          id
          name
        }
        above
        bellow
      }
      errors {
        message
      }
    }
  }
`

export function useQuestionCreateMutation(...args) {
  const [mutation, { data, ...rest }] = useMutation(QUESTION_CREATE_MUTATION, {
    ...args,
    update(cache, { data: { questionCreate } }) {
      cache.modify({
        fields: {
          questionList(existing = [], { readField }) {
            const newQuestionRef = cache.writeFragment({
              data: questionCreate,
              fragment: gql`
                fragment NewQuestion on Question {
                  id
                  type
                  text
                  textFuture
                  description
                  associatedLink
                  notApplicable
                  dimension {
                    id
                    name
                  }
                  recommendations {
                    stage {
                      id
                      name
                    }
                    above
                    bellow
                  }
                }
              `
            })

            if (existing.results.some(ref => readField('id', ref) === questionCreate.id)) {
              return existing
            } else {
              return {
                ...existing,
                results: [...existing.results, newQuestionRef]
              }
            }
          }
        }
      })
    }
  })

  return [
    mutation,
    {
      data: data?.questionCreate,
      ...rest
    }
  ]
}
